import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Checkbox, Radio, Well } from 'react-bootstrap';
import ScheduleFilter from '../common/ScheduleFilters';
import ScheduleEFForm from './ScheduleEFForm';
import './ScheduleEF.less';
import MoneyFormat from '../common/MoneyFormat';
import currencyConversion from '../../utils/currencyConversion';
import EditCopyPasteSchedule from '../common/EditCopyPasteSchedule.jsx';
import ScheduleVerifyToolbar from '../common/ScheduleVeriyToolbar';
import PagedItems from '../common/PagedItems';

class ScheduleEF extends Component {
  getScheduleData = (data) => {
    const { priority_creditors = [], non_priority_creditors = [] } = data;
    const { value_from = '', value_to = '', keyword = '' } = this.props.viewFilters;
    const searchWords = keyword
      .toLowerCase()
      .split(' ')
      .filter((p) => p !== '')
      .reverse();
    const inRange = (value) =>
      (value_from ? currencyConversion.toDollars(value) >= value_from : true) &&
      (value_to ? currencyConversion.toDollars(value) <= value_to : true);
    const filteredPriorityCreditors = priority_creditors
      .map((creditor, index) => ({ ...creditor, index }))
      .filter((priority_creditor) => {
        const text = Object.values(priority_creditor).join(' ').toLowerCase();
        return (
          (_.isEmpty(searchWords) || _.every(searchWords, (word) => text.indexOf(word) > -1)) &&
          (inRange(priority_creditor.total_claim) || inRange(priority_creditor.priority_amount))
        );
      });
    const filteredNonPriorityCreditors = non_priority_creditors
      .map((creditor, index) => ({ ...creditor, index }))
      .filter((non_priority_creditor) => {
        const text = Object.values(non_priority_creditor).join(' ');
        return (
          (_.isEmpty(searchWords) || _.every(searchWords, (word) => text.toLowerCase().indexOf(word) > -1)) &&
          inRange(non_priority_creditor.total_claim)
        );
      });
    const hasFilteredPriorityValues = filteredPriorityCreditors.length > 0;
    const hasFilteredNonPriorityValues = filteredNonPriorityCreditors.length > 0;
    return (
      <React.Fragment>
        {hasFilteredPriorityValues && (
          <React.Fragment>
            <table>
              <thead>
                <tr>
                  <th>Priority creditors</th>
                </tr>
              </thead>
            </table>
            <PagedItems
              records={filteredPriorityCreditors}
              component={({ visibleRecords }) => (
                <table id="priority-creditors">
                  <tbody>{visibleRecords.map((creditor) => this.priority_creditor_item(creditor))}</tbody>
                </table>
              )}
            />
          </React.Fragment>
        )}
        {hasFilteredNonPriorityValues && (
          <React.Fragment>
            <table>
              <thead>
                <tr>
                  <th>Nonpriority creditors</th>
                </tr>
              </thead>
            </table>
            <PagedItems
              records={filteredNonPriorityCreditors}
              component={({ visibleRecords }) => (
                <table id="nonpriority-creditors">
                  <tbody>{visibleRecords.map((creditor) => this.nonpriority_creditor_item(creditor))}</tbody>
                </table>
              )}
            />
          </React.Fragment>
        )}
        {!hasFilteredPriorityValues && !hasFilteredNonPriorityValues && (
          <Well bsSize="small">No results for searched term, try to search something different.</Well>
        )}
      </React.Fragment>
    );
  };

  priority_creditor_item = (creditor) => (
    <tr key={`priority-creditor-${creditor.index}`}>
      <td>
        <table>
          <thead>
            <tr>
              <td colSpan="2">2.{creditor.index + 1}</td>
              <td className="total-claim" align="right">
                <label htmlFor="">
                  <span className="label">Total claim</span>
                </label>
              </td>
              <td className="priority-amount" align="right">
                <label htmlFor="">
                  <span className="label">Priority amount</span>
                </label>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <label htmlFor="">
                  <span className="label">Priority creditor's name and mailing address</span>
                </label>
                <br />
                <span id="address">
                  {creditor.creditor_name}
                  <br />
                  {creditor.creditor_address_street}
                  <br />
                  {creditor.creditor_address_city} {creditor.creditor_address_state}{' '}
                  {creditor.creditor_address_zip_code}
                  <br />
                  {creditor.creditor_address_country}
                </span>
              </td>
              <td>
                <label htmlFor="">
                  <span className="label">As of petition filing date, the claim is:</span>
                </label>
                <Checkbox name="claim_type" readOnly checked={creditor.is_contingent}>
                  {' '}
                  Contingent{' '}
                </Checkbox>
                <Checkbox name="claim_type" readOnly checked={creditor.is_unliquidated}>
                  {' '}
                  Unliquidated{' '}
                </Checkbox>
                <Checkbox name="claim_type" readOnly checked={creditor.is_disputed}>
                  {' '}
                  Disputed{' '}
                </Checkbox>
              </td>
              <td className="money">
                <span id="total-claim">{MoneyFormat(creditor.total_claim)}</span>
              </td>
              <td className="money">
                <span id="priority-amount">{MoneyFormat(creditor.priority_amount)}</span>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="">
                  <span className="label">Date or dates debt was incurred</span>
                </label>
                <br />
                {creditor.debt_date}
              </td>
              <td>
                <label htmlFor="">
                  <span className="label">Basis for the claim</span>
                </label>
                <br />
                {creditor.claim_basis}
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="">
                  <span className="label">Last 4 digits of account number</span>
                </label>
                <br />
                {creditor.account_number_last_4_digits}
              </td>
              <td rowSpan="2">
                <label htmlFor="">
                  <span className="label">Is the claim subject to offset?</span>
                </label>
                <br />
                <Radio
                  name={`is_offset_claim_${creditor.index}_no_priority`}
                  value="No"
                  readOnly
                  checked={!creditor.is_subject_to_offset}
                >
                  No
                </Radio>
                <Radio
                  name={`is_offset_claim_${creditor.index}_yes_priority`}
                  value="Yes"
                  readOnly
                  checked={creditor.is_subject_to_offset}
                >
                  Yes
                </Radio>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="">
                  <span className="label">Specify Code subsection of PRIORITY unsecured claim:</span>
                </label>
                11 U.S.C. § 507(a) ({creditor.usc_subsection})
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  );

  nonpriority_creditor_item = (creditor) => (
    <tr key={`non-priority-creditor-${creditor.index}`}>
      <td>
        <table>
          <thead>
            <tr>
              <td colSpan="2">3.{creditor.index + 1}</td>
              <td className="total-claim">
                <label htmlFor="">
                  <span className="label">Amount of claim</span>
                </label>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowSpan="2">
                <label htmlFor="">
                  <span className="label">Nonpriority creditor's name and mailing address</span>
                </label>
                <br />
                <span id="address">
                  {creditor.creditor_name}
                  <br />
                  {creditor.creditor_address_street}
                  <br />
                  {creditor.creditor_address_city} {creditor.creditor_address_state}{' '}
                  {creditor.creditor_address_zip_code}
                  <br />
                  {creditor.creditor_address_country}
                </span>
              </td>
              <td>
                <label htmlFor="">
                  <span className="label">As of petition filing date, the claim is:</span>
                </label>
                <br />
                <Checkbox name="claim_type" readOnly checked={creditor.is_contingent}>
                  {' '}
                  Contingent{' '}
                </Checkbox>
                <Checkbox name="claim_type" readOnly checked={creditor.is_unliquidated}>
                  {' '}
                  Unliquidated{' '}
                </Checkbox>
                <Checkbox name="claim_type" readOnly checked={creditor.is_disputed}>
                  {' '}
                  Disputed{' '}
                </Checkbox>
              </td>
              <td className="money">
                <span id="total-claim">{MoneyFormat(creditor.total_claim)}</span>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="">
                  <span className="label">Basis for the claim</span>
                </label>
                <br />
                {creditor.claim_basis}
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="">
                  <span className="label">Date or dates debt was incurred</span>
                </label>
                <br />
                {creditor.debt_date}
              </td>
              <td rowSpan="2">
                <label htmlFor="">
                  <span className="label">Is the claim subject to offset?</span>
                </label>
                <br />
                <Radio
                  name={`is_offset_claim_${creditor.index}_no_non_priority`}
                  value="No"
                  readOnly
                  checked={!creditor.is_subject_to_offset}
                >
                  No
                </Radio>
                <Radio
                  name={`is_offset_claim_${creditor.index}_yes_non_priority`}
                  value="Yes"
                  readOnly
                  checked={creditor.is_subject_to_offset}
                >
                  Yes
                </Radio>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="">
                  <span className="label">Last 4 digits of account number</span>
                </label>
                <br />
                {creditor.account_number_last_4_digits}
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  );

  render() {
    const {
      type,
      schedule,
      editScheduleForm,
      canEdit,
      can_see_details,
      onCancel,
      onSubmit,
      onPastedData,
      scheduleFiltersProps,
      toggleScheduleForm,
    } = this.props;

    const tableData = schedule.data || {};
    const noDataFound = schedule.data === null ? 'There is no Schedule EF for this case.' : schedule.empty || null;
    const { priority_creditors = [], non_priority_creditors = [] } = tableData;
    const hasCreditors = priority_creditors.length >= 0 || non_priority_creditors.length >= 0;

    if (noDataFound && !editScheduleForm) {
      return (
        <div id="ir-search-schedule-ef-results">
          <Well bsSize="small">{noDataFound}</Well>
          {canEdit && <ScheduleVerifyToolbar schedule={schedule} />}
          {canEdit && (
            <EditCopyPasteSchedule
              schedule={{ schedule_type: 'ef' }}
              onPastedData={onPastedData}
              toggleScheduleForm={toggleScheduleForm}
            />
          )}
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className={type}>
          {can_see_details && (
            <React.Fragment>
              <div id="schedule-ef">
                <div id="ir-search-schedule-ef-results">
                  {editScheduleForm ? (
                    <ScheduleEFForm
                      {...this.props}
                      // editScheduleForm could be a draft object
                      schedule={editScheduleForm === true ? schedule : editScheduleForm}
                      isDraft={editScheduleForm !== true}
                      onSubmit={onSubmit}
                      onCancel={onCancel}
                    />
                  ) : (
                    <React.Fragment>
                      {hasCreditors && <ScheduleFilter {...scheduleFiltersProps} />}
                      {canEdit && <ScheduleVerifyToolbar schedule={schedule} />}
                      {canEdit && (
                        <EditCopyPasteSchedule
                          schedule={schedule}
                          onPastedData={onPastedData}
                          toggleScheduleForm={toggleScheduleForm}
                        />
                      )}
                      {this.getScheduleData(tableData)}
                    </React.Fragment>
                  )}
                  {canEdit && !editScheduleForm && (
                    <div className="editable">
                      <button className="btn btn-primary" onClick={toggleScheduleForm}>
                        Edit
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );
  }
}

ScheduleEF.defaultProps = {
  type: 'schedule_ef',
  scheduleFiltersProps: {},
  viewFilters: {},
  keyword: '',
  value_from: '',
  value_to: '',
};

ScheduleEF.propTypes = {
  schedule: PropTypes.any.isRequired,
  type: PropTypes.string,
  scheduleFiltersProps: PropTypes.object,
  viewFilters: PropTypes.object,
  keyword: PropTypes.string,
  value_to: PropTypes.string,
  value_from: PropTypes.string,
  editScheduleForm: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  can_see_details: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  toggleScheduleForm: PropTypes.func.isRequired,
};

export default ScheduleEF;



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_ef/ScheduleEF.jsx